import { useIsFocused } from '@react-navigation/native';

/**
 * 웹에서는 native viewWillAppear/viewWillDisappear가 없으므로
 * React Navigation의 focus 상태로 tab focus 여부를 판별한다.
 */
export const useIsFocusedTab = () => useIsFocused();
